import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { WorkspaceService } from 'app/core/workspace/workspace.service';
import { WorkspaceRole } from 'app/core/workspace/workspace.types';
import { map, Observable, of } from 'rxjs';

export const workspaceRoleGuard = (allowedRoles: WorkspaceRole[]): CanActivateFn => {
    return (): boolean | UrlTree | Observable<boolean | UrlTree> => {
        const router = inject(Router);
        const workspaceService = inject(WorkspaceService);

        const check = (role: WorkspaceRole | null | undefined): boolean | UrlTree => {
            if (!role) return router.parseUrl('/no-workspace');
            if (allowedRoles.includes(role)) return true;
            return router.parseUrl(role === 'configurator' ? '/sync' : '/chat');
        };

        if (workspaceService.workspacesLoaded) {
            return of(check(workspaceService.currentSelectedWorkspace?.role));
        }

        return workspaceService.loadForGuard().pipe(
            map(() => check(workspaceService.currentSelectedWorkspace?.role)),
        );
    };
};
